// const ENDPOINT: string = "http://localhost:5000/api"
const ENDPOINT: string = "https://api.foremanx.ai/api"

export default ENDPOINT;